import { IgnoreZone } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const extractPresetZoneRowIdsFromApiResponse = (data: unknown): number[] => {
  const raw = Array.isArray((data as { results?: unknown })?.results)
    ? (data as { results: unknown[] }).results
    : Array.isArray(data)
    ? (data as unknown[])
    : [];
  return raw
    .map((row) => Number((row as { id?: unknown })?.id))
    .filter((id) => Number.isFinite(id));
};

/**
 * Maps zones to preset-zone **row** ids from a fresh `GET preset-zone/?camera=&preset=`.
 * Stale `preset_zone_id` on hydrated zones (e.g. old row 87 after server replaced with 120)
 * must not drive PATCH URLs — only ids returned by the GET are valid.
 */
export const assignZonesToPresetZoneRowIds = (
  zones: IgnoreZone[],
  freshRowIds: number[]
): Map<number, IgnoreZone[]> => {
  const sorted = Array.from(
    new Set(freshRowIds.map((n) => Number(n)).filter((id) => Number.isFinite(id)))
  ).sort((a, b) => a - b);
  if (sorted.length === 0) {
    return new Map();
  }
  if (sorted.length === 1) {
    return new Map([[sorted[0], [...zones]]]);
  }
  const freshSet = new Set(sorted);
  /** Rows removed server-side: merge those zones into the highest id (newest row). */
  const staleIdFallback = Math.max(...sorted);
  const m = new Map<number, IgnoreZone[]>();
  for (const z of zones) {
    const raw = z.preset_zone_id;
    const id = raw != null && Number.isFinite(Number(raw)) ? Number(raw) : null;
    const key = id != null && freshSet.has(id) ? id : staleIdFallback;
    const arr = m.get(key) || [];
    arr.push(z);
    m.set(key, arr);
  }
  return m;
};
